import { type FC } from "react";
import { Container, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { PageContainer } from "@packsize/components";
import { Internal } from "@packsize/authentication";

import { ToolsPageNavCard } from "./components/tools-page-nav-card";
import { SimulatorCard } from "./components/simulator-card";
import { UserInformationCard } from "./components/user-information-card";
import { TokenInformationCard } from "./components/token-information-card";
import { FeatureFlagsCard } from "./components/feature-flags-card";
import { LegacyFeatureFlagsCard } from "./components/legacy-feature-flags-card";
import { PermissionsCard } from "./components/permissions-card";

export const ToolsPage: FC = () => {
	return (
		<PageContainer id="developer-page">
			<Container>
				<Stack spacing={2}>
					<Typography variant="h1">
						<FormattedMessage id="Tools" defaultMessage="Tools" />
					</Typography>

					<Internal>
						<ToolsPageNavCard />
					</Internal>

					<SimulatorCard />

					<Internal>
						<UserInformationCard />
					</Internal>

					<Internal>
						<TokenInformationCard />
					</Internal>

					<Internal>
						<FeatureFlagsCard />
					</Internal>

					<Internal>
						<LegacyFeatureFlagsCard />
					</Internal>

					<Internal>
						<PermissionsCard />
					</Internal>
				</Stack>
			</Container>
		</PageContainer>
	);
};
